import { WidgetChooser } from '../explore/WidgetChooser'

/**
 * Which panels the Board shows this person, in what order, and how each is drawn.
 *
 * The same controls live on the Board itself under Customise, and deliberately so: arranging a
 * dashboard is something you do while looking at it. This is the copy for somebody who came to
 * Settings looking for it, which is where people look for a setting.
 *
 * No heading of its own - the tab names the panel (D-429).
 */
export function DashboardCard() {
  return (
    <div className="card">
      <div className="card-body">
        <p className="muted" style={{ marginTop: 0 }}>
          Which panels appear, in what order, and how each is drawn. The same controls are on the
          dashboard itself under Customise.
        </p>
        <WidgetChooser />
      </div>
    </div>
  )
}
